import React from 'react';
import { AppShell, Text } from '@tapresearch/ui/components';
import { useHistory } from 'react-router-dom';
import { useQueryString } from '../components/hook';
import { BreadcrumbContainer } from '../components/common/Breadcrumb';

export const HeaderContent = ({ isHomepage }: { isHomepage: boolean }) => {
  if (!isHomepage) return <BreadcrumbContainer />;

  return <HomepageTabNav />;
};

const HomepageTabNav = () => {
  const history = useHistory();

  const { managed: isManagedView } = useQueryString();

  const matchedManaged = !!Number(isManagedView);

  const currentIndex = matchedManaged ? 1 : 0;

  const tabs = [
    {
      key: 'self_service',
      label: 'Self-service',
      onClick: () => history.push('/?managed=0'),
    },
    {
      key: 'managed',
      label: 'Managed',
      onClick: () => history.push('/?managed=1'),
    },
  ];
  return (
    <>
      <Text color="trueBlack" fontWeight="medium" fontSize="lg">
        Surveys
      </Text>

      <AppShell.HeaderTabs
        currentIndex={currentIndex >= 0 ? currentIndex : null}
        tabs={tabs}
      />
    </>
  );
};
